/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GetDashboardFacilityDtoRx, GetDashboardRegionDtoRx } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class DashBoardApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags DashBoard API
   * @name DashboardControllerGetDashBoardFacility
   * @summary 대시보드 - 시설물
   * @request GET:/api/dashboard/facility
   * @secure
   */
  dashboardControllerGetDashBoardFacility = (params: RequestParams = {}) =>
    this.request<GetDashboardFacilityDtoRx, any>({
      path: `/api/dashboard/facility`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags DashBoard API
   * @name DashboardControllerGetDashBoardRegion
   * @summary 대시보드 - 지역
   * @request GET:/api/dashboard/region
   * @secure
   */
  dashboardControllerGetDashBoardRegion = (params: RequestParams = {}) =>
    this.request<GetDashboardRegionDtoRx, any>({
      path: `/api/dashboard/region`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
